export default {
  getDataUser(state) {
    return state.listsUsers
  },
  getttersUserSession(state) {
    return state.userSession
  },
}